
// Configuration Brevo
export const BREVO_CONFIG = {
  apiKey: "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", // Clé API v3
  listId: 9, // ID de la liste cible
};

export const BREVO_ENDPOINTS = {
  contacts: "https://api.brevo.com/v3/contacts",
  events: "https://api.brevo.com/v3/events" // Pour le tracking d'événements si nécessaire
};
